import moment from 'moment';
import { US_DATE_FORMAT } from 'utils/appConstants';


export const stringifyDateRange = ({ startAt, endAt, openEnd = 'Open End Date' }) => (endAt
  ? `${moment(startAt)?.format(US_DATE_FORMAT)} - ${moment(endAt).format(US_DATE_FORMAT)}`
  : `${moment(startAt)?.format(US_DATE_FORMAT)} - ${openEnd}`);
